import Category from './Category'
import { Container, SubTitle, LabelRow } from './styles'

export default function CategoryList ({ categories = [], categoryType }) {
  if (categories.length === 0) return (
    <Container>
      <SubTitle>
        0 resultados
      </SubTitle>
    </Container>
  )

  return (
    <Container>
      <SubTitle>
        {categories.length + ' ' + (categories.length === 1 ? 'Resultado' : 'Resultados')}
      </SubTitle>
      <LabelRow>
        <SubTitle>Nome</SubTitle>
        <SubTitle>Descrição</SubTitle>
        <SubTitle>Status</SubTitle>
      </LabelRow>
      {categories.map (category =>
        <Category
          key={category.id}
          data={category}
          categoryType={categoryType}
        />
      )}
    </Container>
  )
}
